import { StaticTokens } from './API';

export const getUserToken = () => {
  const rawUser = localStorage.getItem('user');
  if (!rawUser) {
    return null;
  }
  try {
    return JSON.parse(rawUser)?.token ?? null;
  } catch {
    return null;
  }
};

export function commonHeaders() {
  const token = getUserToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['X-API-TOKEN'] = token;
  }

  return { headers };
}

/** Токен табло: из query-параметра URL (?token=...) или статический fallback */
export function getMonitorToken(): string | null {
  const fromUrl = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('token')
    : null;
  return fromUrl || StaticTokens.monitorToken || null;
}

/** Проверка, что строка — валидный UUID (только ASCII; для заголовков HTTP) */
const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
function isSafeForHeader(value: string | null): value is string {
  return typeof value === 'string' && value.length > 0 && UUID_REGEX.test(value.trim());
}

/** Код филиала из query-параметра URL (?branch=...) для однозначного определения очереди */
export function getMonitorBranchCode(): string | null {
  if (typeof window === 'undefined') return null;
  const code = new URLSearchParams(window.location.search).get('branch');
  return code?.trim() || null;
}

/** Наименование очереди из query-параметра URL (?queue=...) для окна оператора */
export function getOperatorQueueName(): string | null {
  if (typeof window === 'undefined') return null;
  const name = new URLSearchParams(window.location.search).get('queue');
  return name?.trim() || null;
}

export function queueScreenHeaders() {
  const token = getMonitorToken();
  const branch = getMonitorBranchCode();
  const params: Record<string, string> = {};
  if (token) params.token = token;
  if (branch) params.branch = branch;
  const headers: Record<string, string> = {};
  // В заголовки только ASCII (UUID); кириллица в branch передаётся только в params (query)
  if (isSafeForHeader(token)) headers['X-API-TOKEN'] = token;
  return {
    headers: Object.keys(headers).length > 0 ? headers : undefined,
    params: Object.keys(params).length > 0 ? params : undefined
  };
}

export function multipartHeaders() {
  const token = getUserToken();
  const headers: Record<string, string> = {
    'Content-Type': 'multipart/form-data'
  };

  if (token) {
    headers['X-API-TOKEN'] = token;
  }

  return { headers };
}
